export {
    importScript, importLink, removeScript, getHreflangLinks
} from './Script';
